import * as React from 'react';
import {useDeviceSize, DeviceSize} from '../../theme/helpers';
import {Props} from './model';
import View from './view';

export const Breadcrumbs = (props: Props) => {
  const devicesSize = useDeviceSize();

  if (devicesSize !== DeviceSize.desktop) {
    return null;
  }

  return <View {...props} />;
};
